export const MAX_APPLICABLE_INTAKE_FILTERS = 5;
